import React, { useState } from 'react';
import apiClient from '../api/api';
import { FaSearch, FaUserPlus, FaSpinner } from 'react-icons/fa';

function BrokerFindWorkersPage() {
    const [searchTerm, setSearchTerm] = useState('');
    const [searchResults, setSearchResults] = useState([]);
    const [searchLoading, setSearchLoading] = useState(false);

    const [notification, setNotification] = useState(null);

    const showNotification = (message, type = 'success') => {
        setNotification({ message, type });
        setTimeout(() => setNotification(null), 3000);
    };

    const handleSearch = async (e) => {
        e.preventDefault();
        if (!searchTerm.trim()) return;
        setSearchLoading(true);
        try {
            const response = await apiClient.get(`/users/search?phone=${searchTerm}`);
            // Note: In a real app, we should filter out workers already in the roster.
            // For now, we'll just show the results.
            setSearchResults(response.data || []);
        } catch (err) {
            console.error("Search failed:", err);
            showNotification('Search failed. Please try again.', 'error');
        } finally {
            setSearchLoading(false);
        }
    };

    const handleInvite = async (workerProfileId) => {
        try {
            await apiClient.post('/broker/roster/invite', { workerProfileId });
            showNotification('Invitation sent successfully!', 'success');
            setSearchResults(prev => prev.filter(worker => worker.profile.id !== workerProfileId));
        } catch (err) {
            showNotification(err.response?.data?.message || 'Failed to send invitation.', 'error');
        }
    };

    return (
        <div className="space-y-6 relative">
            {notification && (
                <div className={`fixed top-4 right-4 z-50 px-6 py-3 rounded-lg shadow-lg text-white transform transition-all duration-300 ease-in-out ${notification.type === 'success' ? 'bg-green-500' : 'bg-red-500'
                    }`}>
                    {notification.message}
                </div>
            )}

            <h1 className="text-3xl font-bold text-gray-800">Find & Add Workers</h1>

            <div className="bg-white p-6 rounded-2xl shadow-lg">
                <form onSubmit={handleSearch} className="flex space-x-2 mb-6">
                    <input
                        type="text"
                        value={searchTerm}
                        onChange={e => setSearchTerm(e.target.value)}
                        placeholder="Search by phone number..."
                        className="flex-grow p-3 border rounded-lg focus:ring-2 focus:ring-blue-500 outline-none"
                    />
                    <button type="submit" className="bg-blue-500 text-white px-6 py-3 rounded-lg hover:bg-blue-600 transition-colors flex items-center" disabled={searchLoading}>
                        {searchLoading ? <FaSpinner className="animate-spin mr-2" /> : <FaSearch className="mr-2" />}
                        Search
                    </button>
                </form>

                <div className="space-y-4">
                    {searchResults.length > 0 ? (
                        searchResults.map(foundUser => (
                            <div key={foundUser.id} className="p-4 border rounded-xl flex justify-between items-center hover:bg-gray-50 transition-colors">
                                <div>
                                    <p className="font-bold text-lg text-gray-800">{foundUser.profile.name}</p>
                                    <p className="text-sm text-gray-500">{foundUser.contact_No}</p>
                                </div>
                                <button
                                    onClick={() => handleInvite(foundUser.profile.id)}
                                    className="bg-green-500 text-white px-4 py-2 rounded-lg hover:bg-green-600 flex items-center text-sm transition-colors"
                                >
                                    <FaUserPlus className="mr-2" /> Invite to Roster
                                </button>
                            </div>
                        ))
                    ) : (
                        searchTerm && !searchLoading && <p className="text-center text-gray-500 py-4">No workers found with that phone number.</p>
                    )}
                </div>
            </div>
        </div>
    );
}

export default BrokerFindWorkersPage;
